import { KarrotLocalCountryCode } from "@karrotmarket-com/core";
import { formatDistanceToNowStrict } from "date-fns";

import { getDateFnsLocale } from "~/core/getDateFnsLocale";

const BoostedLabelMap = {
  [KarrotLocalCountryCode.KR]: "끌올",
  [KarrotLocalCountryCode.CA]: "boosted",
  [KarrotLocalCountryCode.UK]: "boosted",
  [KarrotLocalCountryCode.US]: "boosted",
  [KarrotLocalCountryCode.JP]: "再アップ",
};

export const getDisplayProductTime = ({
  createdAt,
  boostedAt,
  karrotLocalCountryCode,
}: {
  createdAt: string;
  boostedAt: string;
  karrotLocalCountryCode: KarrotLocalCountryCode;
}) => {
  const boosted = boostedAt > createdAt;
  const dateTime = boosted ? boostedAt : createdAt;
  const localeTime = formatDistanceToNowStrict(new Date(dateTime), {
    addSuffix: true,
    locale: getDateFnsLocale({
      karrotLocalCountryCode,
    }),
  });
  const label = boosted
    ? `${BoostedLabelMap[karrotLocalCountryCode]} ${localeTime}`
    : localeTime;

  return {
    dateTime,
    label,
  };
};
